import { ThemeProvider } from "@emotion/react";
import { LicenseInfo } from "@mui/x-license";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "client";
import { CssBaseline, Show } from "components";
import VersionModal, { MainToaster } from "components/ProductDependencies";
import { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { productRoutes } from "routes";
import { ThemeContainer } from "utils/Theme";
import { currentVersion } from "utils/constants";
import "./index.css";
import { AppProvider } from "Pages/Website/appContent";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const Main = () => {
  const location = useLocation();

  const subDomainName = window.location.host.split(".");

  const navigate = useNavigate();

  const { theme } = ThemeContainer();

  const [openVersionModal, setOpenVersionModal] = useState(false);

  useEffect(() => {
    const getVersion = localStorage.getItem("product-version");
    const token = localStorage.getItem("token");

    if ((!getVersion && token) || (getVersion !== currentVersion && token)) {
      setOpenVersionModal(true);
    }

    if (location?.pathname === "/login" && token) {
      navigate("/app/holdings");
    }
  }, [location]);

  useEffect(() => {
    if (location?.pathname === "/") {
      navigate("/home");
    }
  }, [location?.pathname, navigate]);

  useEffect(() => {
    if (
      !window.location.host.includes("www") &&
      subDomainName?.length === (window.location.host.includes("stage") ? 4 : 3)
    ) {
      localStorage.setItem("subdomain", subDomainName[0]);
    } else {
      localStorage.removeItem("subdomain");
    }
  }, [subDomainName]);

  return (
    <>
      <AppProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              {productRoutes?.map((dataItem) => (
                <Route
                  key={dataItem?.path}
                  path={dataItem?.path}
                  element={dataItem?.element}
                >
                  {dataItem?.child?.map((childItem) => (
                    <Route
                      key={childItem?.path}
                      path={childItem?.path}
                      element={childItem?.element}
                    />
                  ))}
                </Route>
              ))}
            </Routes>
          </ThemeProvider>
        </QueryClientProvider>
      </AppProvider>

      <Show.When isTrue={openVersionModal}>
        <VersionModal open={openVersionModal} setOpen={setOpenVersionModal} />
      </Show.When>

      <MainToaster />
    </>
  );
};
export default Main;
